(function () {
  function createCaretIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.classList.add('icon', 'icon-caret');

    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M10.5 5.25L7 8.75L3.5 5.25');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(path);
    return svg;
  }

  function initFaqAccordions() {
    var pageContent = document.querySelector('.faq-page__content');
    if (!pageContent) return;
    if (pageContent.querySelector('.faq-items')) return; // already initialized

    // The page content may be wrapped in a .page-width div or a custom div by Shopify's editor
    var wrapper = pageContent.querySelector('.page-width') || pageContent;

    // If the only meaningful child is a single div, unwrap one more level
    var meaningfulChildren = Array.from(wrapper.children).filter(function (el) {
      return el.tagName !== 'STYLE' && el.tagName !== 'SCRIPT';
    });
    if (meaningfulChildren.length === 1 && meaningfulChildren[0].tagName === 'DIV') {
      wrapper = meaningfulChildren[0];
    }

    var children = Array.from(wrapper.children);

    var introNodes = [];
    var groups = [];
    var current = null;

    children.forEach(function (el) {
      // Skip injected style tags from the page editor
      if (el.tagName === 'STYLE') return;
      if (/^H[1-6]$/.test(el.tagName)) {
        current = { questionText: el.textContent.trim(), body: [] };
        groups.push(current);
      } else if (current) {
        current.body.push(el.cloneNode(true));
      } else {
        introNodes.push(el.cloneNode(true));
      }
    });

    if (groups.length === 0) return;

    // Build replacement content
    var newContent = document.createElement('div');
    newContent.className = 'faq-page__inner';

    // Render intro paragraph(s)
    introNodes.forEach(function (node) {
      newContent.appendChild(node);
    });

    // Render accordion items
    var itemsContainer = document.createElement('div');
    itemsContainer.className = 'faq-items';

    groups.forEach(function (group) {
      var item = document.createElement('div');
      item.className = 'faq-item';

      var toggle = document.createElement('div');
      toggle.className = 'faq-item__toggle';

      var question = document.createElement('h3');
      question.className = 'faq-item__question';
      question.textContent = group.questionText;

      var icon = document.createElement('div');
      icon.className = 'faq-item__icon';
      icon.appendChild(createCaretIcon());

      toggle.appendChild(question);
      toggle.appendChild(icon);

      var answer = document.createElement('div');
      answer.className = 'faq-item__answer';

      var answerInner = document.createElement('div');
      answerInner.className = 'faq-item__answer-inner';
      group.body.forEach(function (node) {
        answerInner.appendChild(node);
      });
      answer.appendChild(answerInner);

      item.appendChild(toggle);
      item.appendChild(answer);
      itemsContainer.appendChild(item);
    });

    newContent.appendChild(itemsContainer);

    // Replace the wrapper with transformed content
    if (wrapper === pageContent) {
      pageContent.textContent = '';
      pageContent.appendChild(newContent);
    } else {
      wrapper.parentNode.replaceChild(newContent, wrapper);
    }

    // Wire up accordion toggle
    itemsContainer.addEventListener('click', function (e) {
      var toggle = e.target.closest('.faq-item__toggle');
      if (!toggle) return;

      var item = toggle.parentElement;
      var answer = item.querySelector('.faq-item__answer');
      var isActive = item.classList.contains('active');

      // Close all open items
      itemsContainer.querySelectorAll('.faq-item.active').forEach(function (openItem) {
        openItem.classList.remove('active');
        openItem.querySelector('.faq-item__answer').style.maxHeight = null;
      });

      // Open clicked item if it was closed
      if (!isActive) {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  }

  initFaqAccordions();
  document.addEventListener('DOMContentLoaded', initFaqAccordions);
  document.addEventListener('shopify:section:load', initFaqAccordions);
})();
